import React from 'react';

export interface ScaleOption {
    value: number;
    name: string;
}

export interface Question {
    id: string;
    text_he: string;
    scale_key?: string;
}

interface QuestionCardProps {
    question: Question;
    value?: number;
    onChange: (val: number) => void;
    answerScales: Record<string, ScaleOption[]>;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ question, value, onChange, answerScales }) => {
    const scaleKey = question.scale_key || 'agreement';
    const scaleOptions = answerScales?.[scaleKey] || [];

    if (!scaleOptions || scaleOptions.length === 0) {
        return (
            <div className="bg-red-50 p-4 rounded-xl border border-red-100 text-red-500 text-sm">
                שגיאה: לא נמצא סולם תשובה עבור "{scaleKey}"
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 mb-4 transition-all hover:shadow-md">
            <h3 className="text-lg font-medium text-brand-dark mb-6 leading-relaxed">
                {question.text_he}
            </h3>

            <div
                className="grid gap-1 sm:gap-2 w-full max-w-2xl mx-auto"
                style={{ gridTemplateColumns: `repeat(${scaleOptions.length}, minmax(0, 1fr))` }}
            >
                {scaleOptions.map((option) => (
                    <div
                        key={option.value}
                        className="flex flex-col items-center group cursor-pointer"
                        onClick={() => onChange(option.value)}
                    >
                        <button
                            type="button"
                            className={`
                                w-9 h-9 sm:w-12 sm:h-12 rounded-full flex items-center justify-center text-sm sm:text-base font-bold transition-all duration-200 mb-2
                                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-gold
                                ${value === option.value
                                    ? 'bg-brand-gold text-white shadow-lg scale-110'
                                    : 'bg-gray-50 text-gray-400 group-hover:bg-brand-dark group-hover:text-white border border-gray-200'
                                }
                            `}
                        >
                            {option.value}
                        </button>
                        <span
                            className={`text-[9px] sm:text-xs text-center leading-tight transition-colors duration-200 px-0.5 break-words w-full ${value === option.value ? 'text-brand-dark font-semibold' : 'text-gray-400 group-hover:text-brand-dark'
                                }`}
                        >
                            {option.name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionCard;
